import styled from "@emotion/styled";
import { commonColors } from "application/theme";

export const ButtonDefault = styled("button")`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 20px;
  cursor: pointer;
  border-radius: 35px;
  background: ${commonColors.white};
  border: 2px solid ${commonColors.blue700};

  /* font */
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0.08px;
  color: ${commonColors.blue700};
`;

export const ButtonConfirmed = styled("div")`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 20px;
  border-radius: 35px;
  background: ${commonColors.grey50};

  span {
    margin-left: 4px;
    /* font */
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0.08px;
    color: ${commonColors.grey900};
  }

  svg {
    width: 16px;
    height: 16px;
    path {
      fill: ${commonColors.blue700};
    }
  }
`;

export const ButtonQuestion = styled("button")`
  all: unset;
  flex: 1;
  display: flex;
  height: 44px;
  cursor: pointer;
  border-radius: 35px;
  background: linear-gradient(to right, #0063f6 0%, #7db9aa 50%, #b4dc8b 100%);

  .inner {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2px;
    border-radius: 35px;
    background: ${commonColors.white};
  }

  /* font */
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0.08px;
  color: ${commonColors.blue700};
`;

export const ButtonAnswer = styled("button")`
  all: unset;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  cursor: pointer;
  border-radius: 35px;
  background: linear-gradient(270deg, #7db9aa 0%, #0063f6 80%, #005ae2 100%);

  /* font */
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0.08px;
  color: ${commonColors.white};
`;
